import { VerificationListItem } from '@app/store/transport-layer/types/verification';

import { getDocumentsVerifications } from '../verifications';

/**
 * GET 문서 추가 인증 조회
 *
 * 서버에선 인증 수단의 관리 개선을 위해
 * authType, authGuide, authValue 세 개의 속성을 가진 형태로
 * 개선하였습니다. 이는 새로운 인증 수단이 추가되어도 authType만
 * 다른게 관리하면 되는 장점이 있습니다.
 *
 * 휴대폰 본인 인증
 * {
 *   authType: 'MOBILE_IDENTIFICATION',
 *   authGuide: '김모두|01012341234',
 * }
 * 법인 공동인증서
 * {
 *   authType: 'D_CERT',
 *   authGuide: '주식회사 모두싸인|1234567890',
 * }
 * 위 형태를 가진 객체 배열 형태로 응답을 받습니다.
 *
 * 클라이언트에선 실명, 전화번호를 분리해서 관리하는게 좋지만
 * 서버측에서는 여러 곳에서 객체 형태를 변경해야하는 부담이 있어서
 * 응답을 받아서 파싱 후 클라에서 적절한 타입으로 변경하여 사용하는
 * 방향으로 진행합니다.
 *
 * @deprecated This API is forwarded. Due to the path and response is changed in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#a0af43771fae48cb93fa4e7227a25386
 */
export interface ParticipantAuthentication {
  auths: Array<{
    authType: 'PASSWORD' | 'MOBILE_IDENTIFICATION' | 'D_CERT';
    authValue: string | null;
  }>;
  participantId: string;
}

export interface DocumentsParticipantAuthsResponse {
  participantAuths: Array<ParticipantAuthentication>;
}

const convertToDeprecatedAuthsResponse = (verifications: VerificationListItem[]) => {
  return verifications.map((verification) => {
    const { methods } = verification;
    const auths = methods.map((method) => {
      const { type, passValue } = method;
      return {
        authType: type,
        authValue: passValue,
      };
    });
    return {
      auths,
      participantId: verification.participant.id ?? verification.participant.dataLabel,
    };
  });
};

export function getDocumentsParticipantAuths({
  documentId,
  workspaceId,
}: {
  documentId: string;
  workspaceId: string;
}): Promise<ParticipantAuthentication[]> {
  return getDocumentsVerifications({ documentId, workspaceId }).then((v) =>
    convertToDeprecatedAuthsResponse(v)
  );
}
